import { Box, Divider, Drawer, IconButton, Typography } from '@mui/material';
import { MdClose } from 'react-icons/md';
import type { InteractionNotification } from '@/apis/business/agent/callLogs/types';
import NotificationCard from './NotificationCard';
import { BuilderEmptyStateView } from '@/components/Common/BuilderEmptyStateView';

export default function InteractionNotificationsDrawer({
  open,
  onClose,
  notifications,
  formatDate
}: {
  open: boolean;
  onClose: () => void;
  notifications: InteractionNotification[];
  formatDate: (date: string) => string;
}) {
  return (
    <Drawer
      anchor='right'
      open={open}
      onClose={onClose}
      sx={{ zIndex: (theme) => theme.zIndex.drawer + 2 }}
      PaperProps={{ sx: { width: 620, maxWidth: '100vw' } }}
    >
      <Box p={2} display='flex' justifyContent='space-between' alignItems='center'>
        <Typography variant='h6'>Notifications</Typography>
        <IconButton onClick={onClose} aria-label='Close notifications'>
          <MdClose />
        </IconButton>
      </Box>

      <Divider />

      <Box p={2} sx={{ overflowY: 'auto', flex: 1 }}>
        {notifications.length === 0 ? (
          <Box mt={6}>
            <BuilderEmptyStateView />
          </Box>
        ) : (
          notifications.map((notification, index) => (
            <NotificationCard
              key={`${notification.channel}-${notification.id ?? index}`}
              notification={notification}
              formatDate={formatDate}
            />
          ))
        )}
      </Box>
    </Drawer>
  );
}
